/**
 * `validateSearch` of `/requests` (`AM-132 point 10`): the triage bench has no route of its own per
 * request (13 §5.4), so a search hit that leads here carries the id it wants opened, and the queue
 * opens that row's drawer straight away instead of leaving the person to find it in the grid.
 */
export interface RequestsSearch {
  requestId?: string;
}

export function requestsSearchSchema(search: Record<string, unknown>): RequestsSearch {
  const requestId = search['requestId'];
  return typeof requestId === 'string' && requestId.length > 0 ? { requestId } : {};
}
